import moment from 'moment-timezone'

export default {
  data() {
    return {
      isEndDatePickerOpen: false
    }
  },
  methods: {
    getEndDateDefaultPickerValue(startKey = 'start', stateKey = 'filters') {
      const filterState = this[stateKey]
      const startDate = filterState && filterState[startKey]

      return startDate ? moment(startDate) : undefined
    },

    handleEndDateOpenChange(isOpen) {
      this.isEndDatePickerOpen = isOpen
    },

    handleEndDateChange(startKey = 'start', endKey = 'end', stateKey = 'filters') {
      const filterState = this[stateKey]
      const startDate = filterState && filterState[startKey]
      const endDate = filterState && filterState[endKey]

      if (startDate && endDate && moment(endDate).isBefore(startDate, 'day')) {
        this.$set(filterState, startKey, endDate)
      }
    },

    handleStartDateChange(startKey = 'start', endKey = 'end', stateKey = 'filters') {
      const filterState = this[stateKey]
      const startDate = filterState && filterState[startKey]
      const endDate = filterState && filterState[endKey]

      if (startDate && endDate && moment(startDate).isAfter(endDate, 'day')) {
        this.$set(filterState, endKey, startDate)
      }

      this.$nextTick(() => {
        this.isEndDatePickerOpen = true
      })
    }
  }
}
